export const DEFAULT_APP_SORT_FIELD = 'RELEVANCE';
export const DEFAULT_APP_SORT_ORDER = 'DESC';
export const APP_SORT_FIELD_ORDER_TUPLES = [['RELEVANCE', 'DESC'], ['HUB_INSTALLS', 'DESC'], ['FIRST_PUBLISHED', 'DESC'], ['NAME', 'ASC'], ['NAME', 'DESC']];